export default __webpack_public_path__ + "static/media/Xeonity.faeb836b.webarchive";